
import Slider from "react-slick";
import "slick-carousel"; // Ensure slick-carousel is imported
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import React, { useState, useEffect } from 'react'
import { Link, NavLink, useNavigate } from "react-router-dom";
import { apiService } from '../../constants/ApiService';

import { toast } from "react-toastify";
import { useSelector, useDispatch } from 'react-redux';
import { addItem, removeItem } from '../../reducetool/features/cardSlice';
import { subStringProdDescription, subStringProdTitle } from "../../constants/subStringUtils";

function ProductSlider() {
  const authData = useSelector(state => state.authState);

  const settings = {
    arrows: true,
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 4, // Default for large screens (you can adjust this for desktop)
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1024, // Tablet view, for example
        settings: {
          slidesToShow: 3, // 3 items visible for tablet screens
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 768, // Mobile view
        settings: {
          slidesToShow: 2.5, // 2.5 items visible on mobile
          slidesToScroll: 1,
          centerMode: true, // Optional: It makes the center item stand out
          centerPadding: "10px", // Optional: Adds some space around the center item
        },
      },
      {
        breakpoint: 480, // Small mobile screens
        settings: {
          slidesToShow: 2, // 2 items visible on very small screens
          slidesToScroll: 1,
        },
      },
    ],
  };

  const navigate = useNavigate();
  const [itemTable, setItemTable] = useState([]);
  const [totalPage, setTotalPage] = useState();
  const dispatch = useDispatch();

  const [filterTable, setFilterTable] = useState([]);
  const [selectedFilterKey, setSelectedFilterKey] = useState([]);
  const [categoryTable, setCategoryTable] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState("");
  const [categoryTranxFilterData, setCategoryTranxFilterData] = useState([])
  const [subCategory, setSubCategory] = useState("")
  const [filterStyle, setFilterStyle] = useState(false);

  const createAddToCardData = async (product) => {
    try {

      const response = await apiService.get(`/api/AddToCartMaster/AddToCartOneItem?itemId=${product.id}`);

      if (response.response && response.response.data.errors) {
        console.log(response.response?.data?.errors)
      }

      if (response.status === true) {
        // console.log(response.message)
      }
      else {
        console.log(response.message);
      }
    } catch (error) {
      console.log(error)
      alert('SomeThing went wrong!!');
    }
  }

  const handleAddToCart = (product) => {
    //let selectedItem = itemTable.find(item => item.id === productId);
    const updatedProduct = { ...product, product_id: product.id };
    delete updatedProduct.id;

    if (authData.login) {
      createAddToCardData(product);
    }
    // console.log(product)
    dispatch(addItem(updatedProduct));
    toast.success("Great choice! The product is now added to your cart.")
    //navigate("/Cart")
  }



  const getItemData = async (page = 1, limit = 10, categoryName = "", subcategoryName = "", selectedFilterKey) => {
    try {
      let config = {
        headers: {
          'Content-Type': 'application/json', // Important for file upload//s
          'accept': 'application/json'
        }
      };

      const response = await apiService.get(`/api/ProductMaster/GetProductsWithTags`);
      if (response.response && response.response.data.errors) {
        alert(response.response?.data?.errors)
      }
      console.log(response)
      if (response.status === true) {
        setItemTable(response.productWithTagsData ? response.productWithTagsData : [])
        // setTotalPage(response.totalPages)
      }
      else {
        alert(response.message);
      }
    } catch (error) {
      console.log(error)
      alert('SomeThing went wrong!!');
    }
  };


  useEffect(() => {
    getItemData();
  }, [!itemTable]);

  const handlePageClick = (data) => {
    getItemData(data.selected + 1)
  };

  const getFilterMaster = async () => {

    try {
      let config = {
        headers: {
          'Content-Type': 'application/json', // Important for file upload//s
          'accept': 'application/json'
        }
      };

      const response = await apiService.get(`/api/SystemFilterMaster/allfilter`, config)
      if (response.response && response.response.data.errors) {
        alert(response.response?.data?.errors)
      }

      if (response.status === true) {
        setFilterTable(response.systemFilterMasterData)
      }
      else {
        alert(response.message);
      }
    } catch (error) {
      console.log(error)
      alert('SomeThing went wrong!!');
    }
  }

  const handleKeySelection = (key) => {

    const colorIndex = selectedFilterKey.indexOf(key);
    if (colorIndex === -1) {
      setSelectedFilterKey([...selectedFilterKey, key]);
      getItemData(1, 10, selectedCategory, subCategory, [...selectedFilterKey, key])

    } else {
      const updatedColors = [...selectedFilterKey];
      updatedColors.splice(colorIndex, 1);
      setSelectedFilterKey(updatedColors);

      getItemData(1, 10, selectedCategory, subCategory, updatedColors)

    }
  };

  const getCategoryData = async (page = 1, limit = 10, search = "") => {
    try {
      let config = {
        headers: {
          'Content-Type': 'application/json', // Important for file upload//s
          'accept': 'application/json'
        }
      };

      const response = await apiService.get(`/api/CategoryMaster/allcategory?pageNo=${page}&limit=${limit}&searchKey=${search}`, config)
      if (response.response && response.response.data.errors) {
        alert(response.response?.data?.errors)
      }

      if (response.status === true) {
        // console.log(response.categoryMasterData)
        setCategoryTable(response.categoryMasterData)
        // setTotalPage(response.totalPages)
        // alert(response.message);
      }
      else {
        alert(response.message);
      }
    } catch (error) {
      console.log(error)
      alert('SomeThing went wrong!!');
    }
  };

  useEffect(() => {
    getCategoryData();
    getFilterMaster()
  }, [!categoryTable]);

  // const handleCategorySelection = (categoryName) => {

  //     const newCategory = selectedCategory === categoryName ? "" : categoryName;
  //     setSelectedCategory(newCategory);
  //     getItemData(1, 10, newCategory)

  //     let filterData = categoryTable.find((data) => data.category_name === categoryName)
  //     setCategoryTranxFilterData(filterData.categoryTranxMaster)
  // };



  // useEffect(() => {
  //     const queryParamsString = window.location.search; 
  //     const queryParams = new URLSearchParams(queryParamsString);
  //     const categoryName = queryParams.get('categoryName'); 
  //     const subcategoryName = queryParams.get('subcategoryName');


  //     setSelectedCategory(categoryName);
  //     setSubCategory(subcategoryName)
  //     getItemData(1, 10, categoryName,subcategoryName)

  //     console.log(categoryName,subcategoryName)
  // }, []);



  const handleCategorySelection = (categoryName) => {
    setSelectedCategory(prevCategory => {
      const newCategory = prevCategory === categoryName ? "" : categoryName;
      getItemData(1, 10, newCategory);

      const filterData = categoryTable.find(data => data.category_name === newCategory);
      setCategoryTranxFilterData(filterData ? filterData.categoryTranxMaster : []);

      return newCategory;
    });
  };

  const calculateAverageRating = (reviewMaster) => {

    if (!reviewMaster || reviewMaster.length === 0) {
      return 0;
    }

    const ratings = reviewMaster.map(review => review.rating_stars);
    const filteredRatings = ratings.filter(rating => rating != null);

    if (filteredRatings.length === 0) {
      return 0; // Return 0 if there are no valid ratings
    }

    const sum = filteredRatings.reduce((total, rating) => total + rating, 0);
    const averageRating = sum / filteredRatings.length;

    let roundedRating = Math.floor(averageRating); // Round down by default
    if (averageRating - Math.floor(averageRating) >= 0.5) {
      roundedRating++;
    }

    return roundedRating;
  };

  const FilterDisplay = () => {
    setFilterStyle(true);
    if (filterStyle === true) {
      setFilterStyle(false);
    }
  };

  // const getFixedTitleText = (text) => {
  //   const sliced = text.substring(0, 20) + "...";
  //   const title = sliced.padEnd(20, ' ');
  //   return title;
  // };

  // const getFixedDescriptionText = (text) => {
  //   const sliced = text.substring(0, 100);
  //   return sliced.padEnd(100, ' ');
  // };

  return (
    <>
      <style>
        {`
                .slick-prev::before,
.slick-next::before {
  color: #a05f43; /* 💡 Change to your desired color */
  font-size: 24px;
}
        .product-box-3:hover img {
  transform: scale(1.05);
  transition: transform 0.3s ease;
}

.btn.btn-dark {
  background-color: #2c2c2c;
  border: none;
  font-size: 0.9rem;
  letter-spacing: 0.3px;
}

.price-box .price {
  font-size: 1.1rem;
}

.product-footer {
  font-family: 'Poppins', sans-serif;
}

.title-flex {
  position: relative;
  padding-bottom: 0.5rem;
  margin-bottom: 2rem;
}

.title-flex h2 {
  font-family: 'Playfair Display', serif;
  font-weight: 600;
  font-size: 2.2rem;
  color: #1c1c1c;
  position: relative;
}

.title-flex h2::after {
  content: "";
  display: block;
  width: 60px;
  height: 4px;
  background: linear-gradient(to right, #d4af37, #e0c072); /* Gold gradient underline */
  margin-top: 8px;
  border-radius: 2px;
}

.category-slider {
  border-radius: 1rem;
  padding: 2rem 1rem;
}


.add-to-cart-button {
  transition: all 0.3s ease-in-out;
  background-color: #3e3e3e; /* fallback dark theme */
}

.add-to-cart-button:hover {
  background-color: #111; /* darker for hover */
  transform: translateY(-2px);
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.2);
}

.add-to-cart-button:active {
  transform: translateY(1px) scale(0.98);
  box-shadow: inset 0 2px 6px rgba(0, 0, 0, 0.2);
  background-color: #000; /* darkest for click */
}

`}
      </style>

      <section className="section-b-space shop-section mb-2 mt-2"  style={{backgroundColor:"transparent"}}>
        {itemTable.map((category, index) => (
          <div key={index} className="category-slider" style={{backgroundColor:"transparent"}}>
            {/* Section Heading */}


            <div class="about-us-title  text-white">
              <h2  style={{ fontWeight: 700 }}>{category.tagName}</h2>
            </div>


            {/* Product Slider */}
            <Slider {...settings} className="mt-3 mb-5">
              {category.productsList.map((product, idx) => (
                <div key={idx} className="product-box-3 h-100 wow fadeInUp p-2" style={{border: "1px solid #eaeaea !important", borderColor: "#c2a57c !important",borderRadius:"none"}}>
                  <div className="product-header position-relative overflow-hidden rounded-3 shadow-sm">
                    <div className="product-image position-relative">
                      <NavLink 
                      to={`/product-detail/${product.product_slug}/${product.id}`} 
                      state={{ productId: product.id, subcategoryName: product.product_sub_category }}>
                        <img
                          src={process.env.REACT_APP_API_BASE_URL + product.img_url}
                          className="img-fluid blur-up lazyloaded w-100 transition"
                          alt={product.product_title}
                          style={{ borderRadius: '12px', aspectRatio: '1 / 1' }}
                        />
                      </NavLink>
                    </div>
                  </div>

                  <div className="product-footer mt-3 px-2">
                    <div className="product-detail text-start">
                      <span className="badge bg-light text-dark small mb-1">{product.product_sub_category}</span>
                      <NavLink 
                      to={`/product-detail/${product.product_slug}/${product.id}`} 
                      state={{ productId: product.id, subcategoryName: product.product_sub_category }}>
                        <h5 className="fw-semibold lh-sm text-theme">
                          {subStringProdTitle(product.product_title)}
                        </h5>
                        <p className="text-muted mb-2" style={{
                                                                    display: 'inline-block',
                                                                    width: 'ch',
                                                                    whiteSpace: 'pre-wrap', 
                                                                    overflow: 'hidden',
                                                                    height: '4.5em', 
                                                                }}>
                          {subStringProdDescription(product.product_description)}...
                        </p>
                      </NavLink>

                      <div className="price-box mt-2 mb-3">
                        <h5 className="price text-dark mb-1">
                          ₹<span className="fw-bold">{product.sp_after_tax}</span>
                          <del className="text-muted ms-2 small">₹{product.strike_sp}</del>
                        </h5>
                        <span className="text-danger small">({Math.round(product.strike_disc_per)}% off)</span>
                      </div>

                      <div className="add-to-cart-box mt-2">
                        <button
                          className="btn add-to-cart-button theme-bg-color text-white w-100 shadow-sm py-2"
                          onClick={() => handleAddToCart(product)}
                        >
                          <i className="fa fa-shopping-cart me-2"></i>Add to Cart
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </Slider>
          </div>
        ))}
      </section>
    
    </>


  );

}

export default ProductSlider;
